/**
 * @typedef {Object} LatLngBounds
 * @property {number} north - The northernmost latitude.
 * @property {number} south - The southernmost latitude.
 * @property {number} east - The easternmost longitude.
 * @property {number} west - The westernmost longitude.
 */

/** @type {LatLngBounds} */
export const LAT_LNG_BOUNDS = {
  north: 49.384358,
  south: 24.396308,
  east: -66.93457,
  west: -125.0,
};

/**
 * @enum {string}
 */
export const ADDRESS_COMPONENTS = {
  COUNTRY: "country",
  STATE: "administrative_area_level_1",
  COUNTY: "administrative_area_level_2",
  DISTRICT: "administrative_area_level_3",
  CITY: "locality",
  POSTAL_CODE: "postal_code",
};
